const customFilterOption = (option:any, inputValue:string) => {
    const innerLabel = option.data.searchLabel || option.label;
    return innerLabel.toLowerCase().includes(inputValue.toLowerCase());


    /*if (type === 'startsWith') {
        return innerLabel.toLowerCase().startsWith(inputValue.toLowerCase());
    }
    if (type === 'includes') {
        return innerLabel.toLowerCase().includes(inputValue.toLowerCase());
    }*/
};

export default customFilterOption;